import { getDefaultExportFromCjs } from "../../../_virtual/_commonjsHelpers.js";
import { __module as lib } from "../../../_virtual/index12.js";
import { s as scrollbarExports } from "./scrollbar.js";
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var _scrollbar = scrollbarExports, _scrollbar2 = _interopRequireDefault(_scrollbar);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  exports.default = _scrollbar2.default, module.exports = exports.default;
})(lib, lib.exports);
var libExports = lib.exports;
const PerfectScrollbar = /* @__PURE__ */ getDefaultExportFromCjs(libExports);
export {
  PerfectScrollbar as default
};
//# sourceMappingURL=index.js.map
